import Vue from "vue";
import Cognito from "./cognito";
import { AwsConfig } from "./awsConfig";

// cognito関連の処理をプラグインとしてVueインスタンスに登録
Vue.use(Cognito, AwsConfig);

export default new Cognito();
